/* global tUrl */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import './_character.js' // ティザー用　キャラクター処理
import Swiper from 'swiper' // Swiper

// import 'jquery.mb.ytplayer/dist/jquery.mb.YTPlayer' // YTPlayer
// import YouTubePlayer from 'youtube-player' // YTPlayer
import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー

// const debug = true // デバッグフラグ　ログ表示等

jQuery(function($) {
  let canonical = location.href
  canonical = canonical.replace(/\?.*$/, '')

  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close,#menuClose,#' + accBtn + ' a').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass('active')
  })

  /*
       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######
*/

  function trunk8() {
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
          ###          ##    ###    ##     ##
         ## ##         ##   ## ##    ##   ##
        ##   ##        ##  ##   ##    ## ##
       ##     ##       ## ##     ##    ###
       ######### ##    ## #########   ## ##
       ##     ## ##    ## ##     ##  ##   ##
       ##     ##  ######  ##     ## ##     ##
*/

  /**
   * Safariを含めた全ブラウザでスクロールをロックする
   *
   * @function scrollLock
   * @param  {Boolean} [flag=true]  ONOFF切り替え
   * @param  {String} [selector=''html,body]  対象セレクタ
   * @return {Boolean} false
   */

  let scrollTop
  function scrollLock(flag = true, selector = 'html,body') {
    if (flag) {
      // スクロール停止
      if (window.matchMedia('(min-width:769px)').matches) {
        //PC
        $('body').addClass('lock')
      } else {
        //SP
        scrollTop = $(window).scrollTop()
        $(selector).css({ position: 'fixed', top: -scrollTop, width: '100vw' })
      }
    } else {
      // スクロール停止解除
      if (window.matchMedia('(min-width:769px)').matches) {
        //PC
        $('body').removeClass('lock')
      } else {
        //SP
        $(selector).css({ position: 'static', top: '0' })
        $('html,body').scrollTop(scrollTop)
      }
    }
  }

  /*
                #######  ########  ######## ##    ##
               ##     ## ##     ## ##       ###   ##
               ##     ## ##     ## ##       ####  ##
       ####### ##     ## ########  ######   ## ## ##
               ##     ## ##        ##       ##  ####
               ##     ## ##        ##       ##   ###
                #######  ##        ######## ##    ##
*/
  $('.post-load').on('click', 'a', function() {
    $('#news-modal-in').empty()
    $('#overlay').addClass('active')

    const url = $(this).data('url')
    $.ajax({
      url: url,
      dataType: 'html',

      success: function(data) {
        // スクロール停止
        scrollLock(true, '#body-static')

        const outHtml = $($.parseHTML(data)) //parse
        $('#news-modal').addClass('active')
        $('#news-modal-in').html(outHtml.find('#contents')[0].outerHTML)

        if (document.getElementById('op')) {
          window.history.replaceState(
            null,
            null,
            url
              .replace('news/', '?')
              .replace(/\?usecat=1/, '')
              .replace(/\/$/, '')
          ) // TOP用のURLで差し替える
        } else {
          window.history.replaceState(
            null,
            null,
            url
              .replace('news/', 'news/?')
              .replace(/\?usecat=1/, '')
              .replace(/\/$/, '')
          ) // ニュース用のURLで差し替える
        }
      },
      error: function(data) {
        // スクロール停止解除
        scrollLock(false, '#body-static')
      }
    })
    return false
  })
  if ($('#news-item')[0]) {
    // 要素を検出したら実行
    $('#news-modal-in').empty()
    $('#overlay').addClass('active')
    $('#mv')
      .find('.anime')
      .addClass('active')
    const url = $('#news-item').data('url')
    $.ajax({
      url: url,
      dataType: 'html',

      success: function(data) {
        // スクロール停止
        scrollLock(true, '#body-static')

        const outHtml = $($.parseHTML(data)) //parse
        $('#news-modal').addClass('active')
        $('#news-modal-in').html(outHtml.find('#contents')[0].outerHTML)
      },
      error: function(data) {
        // スクロール停止解除
        scrollLock(false, '#body-static')
      }
    })
  }

  /*
               ##     ##  #######  ##     ## ########
               ###   ### ##     ## ##     ## ##
               #### #### ##     ## ##     ## ##
       ####### ## ### ## ##     ## ##     ## ######
               ##     ## ##     ##  ##   ##  ##
               ##     ## ##     ##   ## ##   ##
               ##     ##  #######     ###    ########
*/
  $('#news-modal').on('click', '.post-move', function() {
    $('#news-modal-in').empty()
    $('#bottom-close').removeClass('active')
    $('#modal-loading').addClass('active')
    const url = $(this).attr('href')
    $.ajax({
      url: url,
      dataType: 'html',
      success: function(data) {
        const outHtml = $($.parseHTML(data)) //parse
        $('#news-modal-in').html(outHtml.find('#contents')[0].outerHTML)

        $('#bottom-close').addClass('active')
        $('#modal-loading').removeClass('active')

        if (document.getElementById('op')) {
          window.history.replaceState(
            null,
            null,
            url
              .replace('news/', '?')
              .replace(/\?usecat=1/, '')
              .replace(/\/$/, '')
          ) // TOP用のURLで差し替える
        } else {
          window.history.replaceState(
            null,
            null,
            url
              .replace('news/', 'news/?')
              .replace(/\?usecat=1/, '')
              .replace(/\/$/, '')
          ) // ニュース用のURLで差し替える
        }
      },
      error: function(data) {
        // エラーが起きたら取り敢えずクローズ
        $('#overlay').removeClass('active')
        $('#news-modal').removeClass('active')
        // スクロール停止解除
        scrollLock(false, '#body-static')
      }
    })
    return false
  })

  /*
                ######  ##        #######   ######  ########
               ##    ## ##       ##     ## ##    ## ##
               ##       ##       ##     ## ##       ##
       ####### ##       ##       ##     ##  ######  ######
               ##       ##       ##     ##       ## ##
               ##    ## ##       ##     ## ##    ## ##
                ######  ########  #######   ######  ########
*/
  $('.news-close').on('click', function() {
    $('#overlay').removeClass('active')
    $('#news-modal').removeClass('active')
    $('#news-modal-in').empty()
    // スクロール停止解除
    scrollLock(false, '#body-static')

    window.history.replaceState(null, null, canonical)
  })

  /*
 #### ##    ## ######## #### ##    ## #### ######## ########
  ##  ###   ## ##        ##  ###   ##  ##     ##    ##
  ##  ####  ## ##        ##  ####  ##  ##     ##    ##
  ##  ## ## ## ######    ##  ## ## ##  ##     ##    ######
  ##  ##  #### ##        ##  ##  ####  ##     ##    ##
  ##  ##   ### ##        ##  ##   ###  ##     ##    ##
 #### ##    ## ##       #### ##    ## ####    ##    ########
*/
  /* global InfiniteScroll */
  if ($('.flex-pager.infinite')[0]) {
    //infiniteセットを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const infScroll = new InfiniteScroll('#infinite', {
      //無限スクロール
      path: '.flex-pager a.next', //次のページのURLを持つ要素
      hideNav: '.flex-pager.infinite', //ナビを隠す
      append: '.infinite-post', //表示させる要素を指定
      status: '.page-load-status', //ローダー要素
      history: false, //URLを遷移先のものに変更しない
      //    prefill: true,                //無条件でロードしていく
      scrollThreshold: false, //スクロールをトリガーにしない
      button: '.infinite-next', //指定した要素のクリックをトリガーにする
      onInit: function() {
        // コールバック
        this.on('append', function() {
          // ロード要素設置後
          trunk8()
          observer.observe()
        })
      }
    })
  }

  /*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
  /* global lozad */
  const observer = lozad('.lozad', {
    rootMargin: '3%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  })
  observer.observe()

  /*
       ##        #######     ###    ########
       ##       ##     ##   ## ##   ##     ##
       ##       ##     ##  ##   ##  ##     ##
       ##       ##     ## ######### ##     ##
       ########  #######  ##     ## ########
*/

  /* global imagesLoaded */
  const loadArea = '#loadtarget'
  let skipFlag = false
  // 要素を検出したら実行
  if ($('#load')[0]) {
    if (location.hash === '#news') {
      // ハッシュを検出
      skipFlag = true
    } else if ($('#news-item')[0]) {
      // 要素を検出したら実行
      skipFlag = true
    }
    if (skipFlag) {
      loadEnd() // ロード処理を終わらせる
      opEnd() // OPを終わらせる
    }
    $('#standby').removeClass('active')
    // 画像数を取得
    var imgNum = imagesLoaded(loadArea).images.length
    // 読み込んだ画像の数を格納
    var loadedImg = 0
    // 現在のプログレス値を格納
    var progressNowPosition = 0
    // 1秒間に100回、progressMonitor()を実行する
    var Timer = setInterval(progressMonitor, 1000 / 100)
    // 画像を読み込んだらloadedImgを加算する
    imagesLoaded(loadArea).on('progress', function() {
      ++loadedImg
    })
  }
  // 画像の読み込み状況をチェックし、更新する関数
  function progressMonitor() {
    // 読み込んだ画像のパーセンテージ
    var progressPosition = (loadedImg / imgNum) * 100
    // プログレス値を現在値と目標値からイージングする
    if ($.cookie('opLoaded')) {
      // ロード済みなら高速で100%に
      progressNowPosition += 50
    } else {
      progressNowPosition += (progressPosition - progressNowPosition) * 0.1
    }
    $('#bar').css('right', 100 - progressNowPosition + '%')
    // 読み込みが完了した場合の処理
    if (progressNowPosition >= 100) {
      clearInterval(Timer)
      loadEnd() // ロード処理を終わらせる
    }
    // イージング計算を完了させる
    if (progressNowPosition > 99.9) {
      progressNowPosition = 100
    }
  }
  // ロード処理を終わらせる
  function loadEnd() {
    if (!$.cookie('opLoaded')) {
      $.cookie('opLoaded', 1, { expires: 1, path: '/' }) // ロード済みをCookieで記憶
    }
    $('.anime.stay').addClass('active')
    $('body').removeClass('op-hide')
    if (!skipFlag) {
      $('#op')
        .addClass('active')
        .find('.anime')
        .addClass('active')
      $('html,body').animate({ scrollTop: 0 }, '1')
    }
  }
  /*
 #######  ########
##     ## ##     ##
##     ## ##     ##
##     ## ########
##     ## ##
##     ## ##
 #######  ##
*/

  // Safariで画面を固定する処理
  const displayHold = function(event) {
    event.preventDefault()
  }

  // オープニング
  if ($('#op')[0]) {
    // 1~100の乱数でスポットライト配置
    let randomX
    let randomY
    $('.point').each(function() {
      randomX = Math.ceil(Math.random() * 100)
      randomY = Math.ceil(Math.random() * 100)
      $(this)
        .css('top', randomX + '%')
        .css('left', randomY + '%')
    })

    if (!skipFlag) {
      // 追従要素を隠す
      $('#header').removeClass('active')
      $('#bnr').removeClass('active')

      //スクロールロック
      // $('body').addClass('lock')
      window.addEventListener('touchmove', displayHold, { passive: false })
    }
    // アニメ終了を待つ

    $('#op-timer-end').on('transitionend webkitTransitionEnd animationend webkitAnimationEnd', function() {
      opEnd() // OPを終わらせる
    })
  }

  // OPを終わらせる処理
  function opEnd() {
    // ロード画面を消す
    $('#load').hide()
    // スクロール停止解除
    $('body').removeClass('lock')
    window.removeEventListener('touchmove', displayHold, { passive: false })

    $('#op').removeClass('active')
    $('#mv')
      .find('.anime')
      .addClass('active')
    $('#header').addClass('active')
    $('#bnr').addClass('active')
    $('.lozad-stay').addClass('lozad')
    observer.observe()
  }

  /*
                  ##    ## ######## ##      ##
                  ###   ## ##       ##  ##  ##
                  ####  ## ##       ##  ##  ##
       #######    ## ## ## ######   ##  ##  ##    #######
                  ##  #### ##       ##  ##  ##
                  ##   ### ##       ##  ##  ##
                  ##    ## ########  ###  ###
*/

  /*
 ########     ###    ########     ###
 ##     ##   ## ##   ##     ##   ## ##
 ##     ##  ##   ##  ##     ##  ##   ##
 ########  ##     ## ########  ##     ##
 ##        ######### ##   ##   #########
 ##        ##     ## ##    ##  ##     ##
 ##        ##     ## ##     ## ##     ##
*/
  // パララックス背景　負荷を抑えるためFPS制で処理する
  const fps = 60 // FPS設定 60まで上げるとほとんど負荷低減効果がなくなる
  const frameTime = 1000 / fps
  let isScroll = false // スクロールフラグ
  let scrollY = 0 // 縦方向のスクロール量
  // 処理頻度テスト用
  // let scrollCount = 0
  // let actionCount = 0
  document.addEventListener('scroll', function(ev) {
    // スクロール量の更新だけを行う
    scrollY = window.pageYOffset // スクロール量更新
    isScroll = true // フラグON
    // console.log('Scroll:' + ++scrollCount)
  })
  parallaxBG()
  function parallaxBG() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (isScroll) {
      $('#bgFlag1').css('backgroundPositionY', scrollY * 1.2)
      $('#bgFlag2').css('backgroundPositionY', scrollY * 1.4)
      isScroll = false // フラグをOFFに戻す
      // console.log('Action:' + ++actionCount)
    }
    setTimeout(parallaxBG, frameTime) // 次回の処理を登録
  }

  /*
        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##
*/

  /*
         ########  ##    ## ########
         ##     ## ###   ## ##     ##
         ##     ## ####  ## ##     ##
 ####### ########  ## ## ## ########
         ##     ## ##  #### ##   ##
         ##     ## ##   ### ##    ##
         ########  ##    ## ##     ##
*/
  if ($('#bnr-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    let mySwiper = new Swiper('#bnr-slide', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      slidesPerView: 1, //表示数変更
      loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      spaceBetween: 30, //スライド同士の間隔を空ける
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true,     //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      //    simulateTouch: false,  // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true,      // スライドごとに高さを変動させる
      navigation: {
        nextEl: '.bnr-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.bnr-button-prev' // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        767: {
          slidesPerView: 3 //表示数変更
        }
      }
    })
  }

  if ($('#chara-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const charaSwiper = new Swiper('#chara-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10,  //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      // slidesPerView: 5,   //表示数変更
      // spaceBetween: 20,   //スライド同士の間隔を空ける
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true,     //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      grabCursor: true, // 掴みカーソル
      //    simulateTouch: false,  // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true,      // スライドごとに高さを変動させる
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.chara-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.chara-button-prev' // 次のページボタンを呼び出す要素
      },

      pagination: {
        // ページャーオプション
        el: '.chara-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function(index, className) {
          // bulletsの描画内容改変　画像のサムネイルにする
          ++index // 0から始まるので+1で補正
          return (
            '<div class="' +
            className +
            '"><img src="' +
            tUrl +
            'img/top_chara_btn_' +
            index +
            '.png" alt="ユニット' +
            index +
            '" /></div>'
          )
        }
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        728: {}
      }
    })
    charaSwiper.on('slideChangeTransitionStart slideChangeTransitionEnd touchEnd', function() {
      //スライド完了時のトリガー
      const index = $('#chara-slide')
        .find('.swiper-slide-active')
        .attr('data-no')

      // console.log(index)
      $('.charaSW').removeClass('active')
      $('.charaSW[data-chara="' + index + '"]').addClass('active')

      // console.log(this.realIndex + 1);
    })
  }
  /*
               ##     ## ##    ## #### ########
               ##     ## ###   ##  ##     ##
               ##     ## ####  ##  ##     ##
       ####### ##     ## ## ## ##  ##     ##
               ##     ## ##  ####  ##     ##
               ##     ## ##   ###  ##     ##
                #######  ##    ## ####    ##
*/
  if ($('#unit-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const unitSwiper = new Swiper('#unit-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 300, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      grabCursor: true, // 掴みカーソル

      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },

      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--unit', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function(index, className) {
          // bulletsの描画内容を改変
          return (
            '<div class="' +
            className +
            '"><img src=" ' +
            tUrl +
            'img/character_btn_' +
            (index + 1) +
            '.png" alt="' +
            (index + 1) +
            '" /></div>'
          )
        }
      },
      navigation: {
        nextEl: '.swiper-button-next--unit', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--unit' // 次のページボタンを呼び出す要素
      }
    })
  }

  /*
       ##     ##  #######  ##     ## #### ########
       ###   ### ##     ## ##     ##  ##  ##
       #### #### ##     ## ##     ##  ##  ##
       ## ### ## ##     ## ##     ##  ##  ######
       ##     ## ##     ##  ##   ##   ##  ##
       ##     ## ##     ##   ## ##    ##  ##
       ##     ##  #######     ###    #### ########
*/

  if ($('#movie-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const movieSwiper = new Swiper('#movie-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      // allowTouchMove: false,
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      // slidesPerView: 5, //表示数変更
      // spaceBetween: 20, //スライド同士の間隔を空ける
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true, // スライドごとに高さを変動させる
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--movie', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--movie' // 次のページボタンを呼び出す要素
      },

      pagination: {
        // ページャーオプション
        el: '.movie-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true // クリックでジャンプ可能にする
      },
      on: {
        init: function() {
          // 初期化完了時のコールバック
          // console.log('Movie')
          $('.yt-player').YTPlayer()

          $('.movie-link').on({
            touchstart: function() {
              this.isTouch = true
            },
            touchmove: function() {
              this.isTouch = false
            },
            touchend: function() {
              if (this.isTouch === true) {
                const movieID = $(this).attr('data-movie')
                scrollLock(true, '#body-static')
                $('#news-modal-in').empty()
                $('#overlay').addClass('active')
                $('#news-modal').addClass('active')
                $('#news-modal-in')
                  .append(
                    '<div class="modal__movie__frame flex vcenter hcenter"><div class="modal__movie__frame__in"><div class="wrap w1280 sp-wrap"><div class="youtube-wrap"><iframe width="1280" height="720" src="https://www.youtube.com/embed/' +
                      movieID +
                      '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div></div></div>'
                  )
                  .animate({ scrollTop: 0 }, '1')
                  .focus()
                return false
              }
            }
          })

          $('#movie-slide').on('click', '.movie-link', function() {
            const movieID = $(this).attr('data-movie')
            scrollLock(true, '#body-static')

            $('#bottom-close').removeClass('active')
            $('#news-modal-in').empty()
            $('#overlay').addClass('active')
            $('#news-modal').addClass('active')
            $('#news-modal-in')
              .append(
                '<div class="modal__movie__frame flex vcenter hcenter"><div class="modal__movie__frame__in"><div class="wrap w1280 sp-wrap"><div class="youtube-wrap"><iframe width="1280" height="720" src="https://www.youtube.com/embed/' +
                  movieID +
                  '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div></div></div>'
              )
              .animate({ scrollTop: 0 }, '1')
              .focus()
            return false
          })
        }
      }
    })
  }

  /*
       ########  ##    ## ########
       ##     ## ###   ## ##     ##
       ##     ## ####  ## ##     ##
       ########  ## ## ## ########
       ##     ## ##  #### ##   ##
       ##     ## ##   ### ##    ##
       ########  ##    ## ##     ##
*/
  // バナーレイヤーの高さ（全体-フッター）を定義
  let footerHeight = $('#footer').outerHeight()
  let bnrIsScroll = false
  let bnrScrollY = window.pageYOffset
  let bnrIsSticky = false
  if ($('#bnrLayer')[0]) {
    // 要素を検出したら実行
    const fps = 30 // FPS設定 60まで上げるとほとんど負荷低減効果がなくなる
    const frameTime = 1000 / fps

    window.addEventListener('resize', function() {
      footerHeight = $('#footer').outerHeight() // フッターの高さ情報更新
    })
    document.addEventListener('scroll', function(ev) {
      // スクロール量の更新だけを行う
      bnrScrollY = window.pageYOffset // スクロール量更新
      bnrIsScroll = true // フラグON
      // console.log('Scroll:' + ++scrollCount)
    })
    bnrSticky(frameTime, scrollY)
  }
  function bnrSticky(frameTime) {
    // スクロールフラグが立っているときだけ動作

    if (bnrIsScroll) {
      // console.log('scroll' + bnrScrollY)
      // console.log('footer' + footerHeight)
      // console.log('footer' + ($('body').outerHeight() - footerHeight))
      if (bnrScrollY + screen.height >= $('body').outerHeight() - footerHeight) {
        if (!bnrIsSticky) {
          $('#bnrLayer')
            .css('position', 'absolute')
            .css('bottom', footerHeight + 'px')
          bnrIsSticky = true
        }
      } else {
        if (bnrIsSticky) {
          $('#bnrLayer').attr('style', '')
          bnrIsSticky = false
        }
      }
      bnrIsScroll = false // フラグをOFFに戻す
    }
    setTimeout(bnrSticky, frameTime) // 次回の処理を登録
  }

  /*
        ######  ##     ##    ###    ########     ###
       ##    ## ##     ##   ## ##   ##     ##   ## ##
       ##       ##     ##  ##   ##  ##     ##  ##   ##
       ##       ######### ##     ## ########  ##     ##
       ##       ##     ## ######### ##   ##   #########
       ##    ## ##     ## ##     ## ##    ##  ##     ##
        ######  ##     ## ##     ## ##     ## ##     ##
*/
  function dioagram(id, url, alt) {
    $('#news-modal-in').empty()
    $('#overlay').addClass('active')
    // スクロール停止
    scrollLock(true, '#body-static')

    $('#news-modal').addClass('active')

    $('#news-modal-in').html(
      '<div id="modal-contents" class="l-contents l-page l-news-s chara-diagram"><div id="news-main" class="l-main ta-center"><img class="pc" src="' +
        tUrl +
        'img/character_diagram' +
        id +
        '.jpg?v2" alt="' +
        alt +
        '"><img class="sp" src="' +
        tUrl +
        'img/character_diagram' +
        id +
        '_sp.jpg?v2" alt="' +
        alt +
        '"></div></div>'
    )

    window.history.replaceState(null, null, url) // URL差し替え

    return false
  }
  $('.diagram-modal').on('click', function() {
    const url = $(this).attr('data-url')
    const alt = $(this).attr('data-alt')
    const id = $(this).attr('data-id')
    dioagram(id, url, alt)
  })
  if (document.getElementById('open-diagram')) {
    const elm = document.getElementById('open-diagram')
    const url = elm.getAttribute('data-url')
    const alt = elm.getAttribute('data-alt')
    const id = elm.getAttribute('data-id')
    dioagram(id, url, alt)
  }

  /*
        ######  ##    ## ##    ##  ######
       ##    ##  ##  ##  ###   ## ##    ##
       ##         ####   ####  ## ##
        ######     ##    ## ## ## ##
             ##    ##    ##  #### ##
       ##    ##    ##    ##   ### ##    ##
        ######     ##    ##    ##  ######
*/

  $('.hoverSync').on({
    mouseenter: function() {
      const tag = $(this).attr('data-tag')
      $('.hoverSync').removeClass('active')
      $('.hoverSync--' + tag).addClass('active')
    },
    mouseleave: function() {
      $('.hoverSync').removeClass('active')
    }
  })

  /*
          ###    ##       ########  ##     ##    ###
         ## ##   ##       ##     ## ##     ##   ## ##
        ##   ##  ##       ##     ## ##     ##  ##   ##
       ##     ## ##       ########  ######### ##     ##
       ######### ##       ##        ##     ## #########
       ##     ## ##       ##        ##     ## ##     ##
       ##     ## ######## ##        ##     ## ##     ##
*/
  // // /* global AlphaPicker */

  // $('.opEvent').each(function() {
  //   const alpha = AlphaPicker($(this)[0])
  //   alpha
  //     .click(function(e) {
  //       if (e.alpha) {
  //         alert('click!')
  //       }
  //     })
  //     .mousemove(function(e) {
  //       if (e.alpha) {
  //         $('.opEvent').removeClass('active')
  //         this.classList.add('active')
  //       } else {
  //         this.classList.remove('active')
  //       }
  //     })
  // })

  /*
        ######  ##     ##         ########  #######   ######    ######   ##       ########
       ##    ## ##     ##            ##    ##     ## ##    ##  ##    ##  ##       ##
       ##       ##     ##            ##    ##     ## ##        ##        ##       ##
       ##       ######### #######    ##    ##     ## ##   #### ##   #### ##       ######
       ##       ##     ##            ##    ##     ## ##    ##  ##    ##  ##       ##
       ##    ## ##     ##            ##    ##     ## ##    ##  ##    ##  ##       ##
        ######  ##     ##            ##     #######   ######    ######   ######## ########
*/

  $('#cModalPoint').on('click', '.chToggleSW', function() {
    $('.chToggle').toggleClass('active')
  })

  /*
        ######          ##     ##  #######  ########     ###    ##
       ##    ##         ###   ### ##     ## ##     ##   ## ##   ##
       ##               #### #### ##     ## ##     ##  ##   ##  ##
       ##       ####### ## ### ## ##     ## ##     ## ##     ## ##
       ##               ##     ## ##     ## ##     ## ######### ##
       ##    ##         ##     ## ##     ## ##     ## ##     ## ##
        ######          ##     ##  #######  ########  ##     ## ########
*/
  if (document.getElementById('cModalStandby')) {
    const elm = document.getElementById('cModalStandby')
    const url = elm.getAttribute('data-url')

    // スクロール停止
    scrollLock(true, '#body-static')

    $('#cModalOverlay').addClass('active')
    $('#cModal').addClass('active')
    $('#bnrLayer').hide()

    window.history.replaceState(null, null, url) // URL差し替え
  }

  $('.cModalOpen').on('click', function() {
    const url = $(this).attr('data-url')

    window.history.replaceState(null, null, url) // URL差し替え
    $('#cModalOverlay').addClass('active')
    // スクロール停止
    scrollLock(true, '#body-static')
    $('#bnrLayer').hide()
    $('#cModalPoint').html('')
    $.ajax({
      url: url + '&modal=1',
      dataType: 'html',
      success: function(data) {
        const outHtml = $($.parseHTML(data)) //parse

        $('#cModalPoint').html(outHtml.find('#cModal')[0].outerHTML)
      },
      error: function(data) {
        // スクロール停止解除
        scrollLock(false, '#body-static')
      }
    })
    return false
  })
  $('#cModalPoint').on('click', '.cModalMove', function() {
    const url = $(this).attr('data-url')
    $('#cModalPoint').html('')

    $.ajax({
      url: url + '&modal=1',
      dataType: 'html',
      success: function(data) {
        const outHtml = $($.parseHTML(data)) //parse

        $('#cModalPoint').html(outHtml.find('#cModal')[0].outerHTML)

        window.history.replaceState(null, null, url) // URL差し替え
      },
      error: function(data) {
        // スクロール停止解除
        scrollLock(false, '#body-static')
      }
    })
    return false
  })
  $('#cModalPoint').on('click', '.cModalClose', function() {
    scrollLock(false, '#body-static')
    $('#cModalOverlay').removeClass('active')
    $('#cModal').removeClass('active')

    $('#bnrLayer').show()

    window.history.replaceState(null, null, './') // URL差し替え
  })
  /*
       ##     ##  #######  ####  ######  ########
       ##     ## ##     ##  ##  ##    ## ##
       ##     ## ##     ##  ##  ##       ##
       ##     ## ##     ##  ##  ##       ######
        ##   ##  ##     ##  ##  ##       ##
         ## ##   ##     ##  ##  ##    ## ##
          ###     #######  ####  ######  ########
*/
  // グローバル変数
  let soundFiles = {
    flag: {},
    currentTime: null
  }

  $(document).on('click', '.audioPlay', function() {
    // ファイル名の取得
    const target = $(this)
    const file = target.attr('data-voice')
    $('.audioPlay').removeClass('active')
    target.addClass('active')

    // 一度生成したエレメントは生成しない
    if (typeof soundFiles.flag[file] === 'undefined' || soundFiles.flag[file] !== 1) {
      // 生成するエレメントの調整
      const audio = document.createElement('audio')

      // エレメントのIDを指定
      audio.id = file

      // ブラウザが[.mp3]に対応している場合は[.mp3]を読み込む
      if (audio.canPlayType('audio/mp3')) {
        audio.src = file + '.mp3'
      } else if (audio.canPlayType('audio/wav')) {
        // ブラウザが[.wav]に対応している場合は[.wav]を読み込む
        audio.src = file + '.wav'
      }

      // [audio]を生成する
      document.body.appendChild(audio)
    }

    // 初回再生以外だったら音声ファイルを巻き戻す
    stopCurrentSound()

    const player = document.getElementById(file)
    // 音声ファイルを再生[play()]する
    player.play()
    player.addEventListener('ended', function() {
      player.currentTime = 0
      target.removeClass('active')
    })

    // 最近再生した音声としてセット
    soundFiles.currentTime = file

    // 初回再生が終わった判定用に[soundFiles.flag]の値を0から1に変更する
    // エレメントを何度も生成しないようにするため
    soundFiles.flag[file] = 1

    // 終了
    return false
  })

  // 前回の音声を停止する関数
  function stopCurrentSound() {
    var currentSound = document.getElementById(soundFiles.currentTime)

    if (currentSound != null) {
      currentSound.pause()
      currentSound.currentTime = 0
    }
  }

  /*
 #### ########         ########  ##
  ##  ##               ##     ## ##
  ##  ##               ##     ## ##
  ##  ######   ####### ##     ## ##
  ##  ##               ##     ## ##
  ##  ##               ##     ## ##
 #### ########         ########  ########
*/
  // IEはdownload属性が効かないので分岐
  if (window.navigator.msSaveOrOpenBlob) {
    $('.js-download').on('click', function() {
      const fileName = $(this).attr('data-filename')
      const uri = $(this).attr('href')

      var xhr = new XMLHttpRequest()
      xhr.open('GET', uri)
      xhr.responseType = 'blob'
      xhr.onloadend = function() {
        if (xhr.status !== 200) {
          return false
        }
        window.navigator.msSaveOrOpenBlob(xhr.response, fileName)
      }
      xhr.send()

      return false
    })
  }

  /*
  ######     ###     ######  ########
 ##        ##   ##  ##          ##
 ##       ##     ##  ######     ##
 ##       #########       ##    ##
  ######  ##     ##  ######     ##
*/

  function castAcc(target) {
    $(target).toggleClass('active')

    $('html , body')
      .not(':animated')
      .animate({ scrollTop: $(target + '-btn').offset().top - $('#header').outerHeight() }, 500, 'swing')
  }
  $('.js-accToggle').on('click ', function() {
    const target = $(this).attr('data-target')

    castAcc(target)
  })

  /*
       ########  ########  ########  ######  ######## ##    ## ########
       ##     ## ##     ## ##       ##       ##       ####  ##    ##
       ########  ########  ######    ######  ######   ## ## ##    ##
       ##        ##   ##   ##             ## ##       ##  ####    ##
       ##        ##     ## ########  ######  ######## ##    ##    ##
*/

  /*
          ######   #######  ##        #######  ########
         ##    ## ##     ## ##       ##     ## ##     ##
         ##       ##     ## ##       ##     ## ##     ##
 ####### ##       ##     ## ##       ##     ## ########
         ##       ##     ## ##       ##     ## ##   ##
         ##    ## ##     ## ##       ##     ## ##    ##
          ######   #######  ########  #######  ##     ##
*/

  $('#present').on('change ', function() {
    // 選択した要素をキャッシュ
    const select = $(this).find('option:selected')
    const color = select.data('color')

    // CSS切り替え
    $('.js-changeBG')
      .css('background', color)
      .css('transitionDelay', '0s')
    $('.js-changeBD').css('borderColor', color)
  })

  /*
         ########  ######## ########  ##     ##  ######
         ##     ## ##       ##     ## ##     ## ##    ##
         ##     ## ##       ##     ## ##     ## ##
 ####### ##     ## ######   ########  ##     ## ##   ####
         ##     ## ##       ##     ## ##     ## ##    ##
         ##     ## ##       ##     ## ##     ## ##    ##
         ########  ######## ########   #######   ######
*/
  // デバッグ用処理
  if (location.hash === '#--debug-present-error') {
    // ハッシュを検出したら実行
    $('#present-overlay').addClass('active')
    $('#present-error').addClass('active')
    scrollLock(true, '#body-static')
  }
  if (location.hash === '#--debug-present-conf') {
    // ハッシュを検出したら実行
    $('#present-overlay').addClass('active')
    $('#present-conf').addClass('active')
    scrollLock(true, '#body-static')
  }
  if (location.hash === '#--debug-present-conf2') {
    // ハッシュを検出したら実行
    $('#present-overlay').addClass('active')
    $('#present-conf2').addClass('active')
    scrollLock(true, '#body-static')
  }
  if (location.hash === '#--debug-present-conf3') {
    // ハッシュを検出したら実行
    $('#present-overlay').addClass('active')
    $('#present-conf3').addClass('active')
    scrollLock(true, '#body-static')
  }
  if (location.hash === '#--debug-present-send') {
    // ハッシュを検出したら実行
    $('#present-overlay').addClass('active')
    $('#present-send').addClass('active')
    scrollLock(true, '#body-static')
  }

  /*
                ######  ##        #######   ######  ########
               ##    ## ##       ##     ## ##    ## ##
               ##       ##       ##     ## ##       ##
       ####### ##       ##       ##     ##  ######  ######
               ##       ##       ##     ##       ## ##
               ##    ## ##       ##     ## ##    ## ##
                ######  ########  #######   ######  ########
*/

  $(document).on('click', '.js-present-close', function() {
    $('#present-overlay').removeClass('active')
    $('.js-present').removeClass('active')
    scrollLock(false, '#body-static')
  })

  /*
                ######   ######  ########   #######  ##       ##
               ##    ## ##    ## ##     ## ##     ## ##       ##
               ##       ##       ##     ## ##     ## ##       ##
       #######  ######  ##       ########  ##     ## ##       ##
                     ## ##       ##   ##   ##     ## ##       ##
               ##    ## ##    ## ##    ##  ##     ## ##       ##
                ######   ######  ##     ##  #######  ######## ########
*/

  $('.scroll-box').each(function() {
    // eslint-disable-next-line no-unused-vars
    const orgScrollbar = new PerfectScrollbar($(this)[0])
  })
})
